export default {
  BP_200: 'BP_200',
  BP_401: 'BP_401',
  BP_403: 'BP_403',
  BP_404: 'BP_404',
  BP_431: 'BP_431',
  BP_400: 'BP_400',
  BP_405: 'BP_405',
  BP_409: 'BP_409',
  BP_412: 'BP_412',
  BP_500: 'BP_500'
}
